<!--<div class="pos_header">
    <div class="menu_bar w-100" (click)="showHideMenu()">
        <i class="pi pi-align-left"></i>
    </div>
    <div class="header_user w-100">
        <app-change-language class="language_change" [ShowFullName]="true"></app-change-language>
        <div *ngIf="isUserGeneralManager()" class="div_products">
            <div class="products_dropdown" (click)="menu_products.toggle($event)">
              <i class="pi c-icons-white menu-icon"></i>
            </div>
          </div>
        <div class="user_info">
            <label class=" user_lbl_name"> {{firstNameLastName}} </label>
            <label class=" user_lbl_email">{{email}}</label>
        </div>
        <div>
            <img src="{{imagePath}}" class="user_image" alt="User Image" (click)="menu_user.toggle($event)">
        </div>
    </div>
    <p-menu #menu_user class="edit-menu" id="user_menu" [popup]="true" [model]="isUserGeneralManager() ? adminItems : items"></p-menu>
    <ng-container>
        <p-overlayPanel #menu_products styleClass="products-menu" id="menu_products"
           [dismissable]="true">
          <div (click)="$event.stopPropagation()">
            <ng-container *ngIf="productList.length > 0">
              <div class="products-container">
                <div *ngFor="let product of productList" class="div-card-product cursor-pointer" (click)="goToProductUrl(product.url)">
                  <div class="d-flex flex-wrap justify-content-center logo-container">
                    <img class="product-logo" [src]="product.pictureUrl" alt="profile-picture">
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="p-menuitem-link" (click)="goToDashboard();">{{'HEADER.GO_TO_DASHBOARD' | translate}}</div>
          </div>
        </p-overlayPanel>
      </ng-container>
</div> -->
<div class="pos-header">
  <div class="pos-header-content">
    <app-change-language class="language_change" [ShowFullName]="true"></app-change-language>
    <div class="pos-products-menu" (click)="menu_products.toggle($event)" ><i class="pi c-icons-white menu-icon"></i></div>
    <div class="pos-user">
      <span class="pos-username">{{firstNameLastName}}</span>
      <span class="pos-role"></span>
    </div>
    <img src="{{imagePath}}" class="user-img" alt="User Image" (click)="menu_user.toggle($event)">
  </div>
</div>
<ng-container>
  <p-overlayPanel #menu_products styleClass="soc-panel-management-menu" [dismissable]="true">
    <div (click)="$event.stopPropagation()" class="d-grid gap-2">
      <ng-container *ngIf="productList.length > 0">
          <div *ngFor="let product of productList" class="product-wrap cursor-pointer" (click)="goToProductUrl(product.url)">
              <img [src]="product.pictureUrl" alt="app-logo">
          </div>
      </ng-container>
      <div id="go-to-dashboard" (click)="goToDashboard();">
        <span class="material-icons cyan">dashboard</span>
        <span class="soc-span-text">{{'HEADER.GO_TO_DASHBOARD' | translate}}</span>
      </div>
    </div>
  </p-overlayPanel>
</ng-container>
<p-menu #menu_user class="soc-user-actions-menu" [popup]="true" [model]="isUserGeneralManager() ? adminItems : items">
</p-menu>
